import { gridBreakpoints, MAX_SIZE_TABLET } from '../theme/mediaQueries';

const isTablet = () => {
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    const hasCoarsePointer = window.matchMedia('(pointer: coarse)').matches;
    const touchCapable = hasTouch || hasCoarsePointer;

    const screenMin = Math.min(window.innerWidth, window.innerHeight);
    const screenMax = Math.max(window.innerWidth, window.innerHeight);

    return (
        touchCapable &&
        screenMin >= gridBreakpoints.tablet &&
        screenMin < gridBreakpoints.desktop &&
        screenMax <= MAX_SIZE_TABLET
    );
};

export default isTablet;
